import { useRef, useState } from 'react';
import styled from 'styled-components';

const Tooltip = ({ children }) => {
  const [fromBottom, setFromBottom] = useState(0);

  const tooltipRef = useRef();

  const handleMouseOver = () => {
    setFromBottom(tooltipRef.current.getBoundingClientRect().bottom);
  };

  return (
    <TooltipContainer ref={tooltipRef} onMouseEnter={handleMouseOver}>
      {children}
      <TooltipText bottom={fromBottom}>
        Här kommer en liten förklaring till vad detta är för något. Och vad
        händer om texten blir lite längre
      </TooltipText>
    </TooltipContainer>
  );
};

Tooltip.propTypes = {};

export default Tooltip;

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const TooltipText = styled.span`
  position: absolute;
  width: 15rem;
  background-color: #000;
  font-size: 0.8rem;
  font-weight: 300;
  color: #ccc;
  padding: 0.5rem;
  border-radius: 0.5rem;
  z-index: 10;
  // margin-left: 2rem;
  // margin-right: 2rem;
  top: 1.5rem;
  left: -6.5rem;
`;
